module.exports = "<p>\n  workflow-detail works!\n</p>\n"